// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import { connect } from 'react-redux';

import { UserDO } from 'wdna-components/lib/types.new';
import { LayoutSkin } from 'wdna-components/lib/layout/types';

import Auth from '../../services/auth/Auth';

import { RootState } from '../../reducers';
import UserMenu from './header/UserMenu';
import LocationDateIndicator from './header/LocationDateIndicator';

const defaultLogo: string = 'assets/img/operators/logo.png';

interface Props {
  skinConfig?: LayoutSkin;
}

type State = unknown;

class Header extends React.Component<Props, State> {
  public landing = (): string => {
    const user: UserDO | null = Auth.getUser();
    if (user && user.access?.role.toUpperCase() === 'CLIENT') {
      const dashboard: string = user.access?.dashboards?.split(',')?.[0] || '';
      if (dashboard === 'dashboard_waste') return '/dashboard/waste';
      if (dashboard === 'dashboard_gtracking') return '/dashboard/gtracking';
      if (dashboard === 'dashboard_meteo') return '/dashboard/meteo';
      return '/dashboard/fboard';
    }

    return '/landing';
  };

  public render(): JSX.Element {
    const { skinConfig } = this.props;

    return (
      <header id="header">
        <div id="logo-group">
          <span id="logo">
            <a href={`#${this.landing()}`}><img src={skinConfig?.logo || defaultLogo} alt="EntropySmart-IOT" /></a>
          </span>
          <UserMenu />
        </div>
        <div className="location-date-container">
          <LocationDateIndicator />
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state: RootState, ownProps: Props): Props => {
  return {
    ...ownProps,
    skinConfig: _.get(state, ['layout', 'skin'], undefined),
  };
};

export default connect(mapStateToProps)(Header);
